import { QueryClient, queryOptions } from "@tanstack/react-query";
import { usersApi } from "@wtf/shared/api/users";
import { normalizeCollection } from "@wtf/shared";

/**
 * Query options factory for user collections
 * Provides consistent caching strategy and normalization
 */
export const userCollectionsQueryOptions = (
  queryClient: QueryClient,
  userId: string | undefined,
  params: { page?: number; limit?: number } = {}
) => {
  return queryOptions<string[]>({
    queryKey: ["user", userId, "collections", params],
    queryFn: async () => {
      if (!userId) throw new Error("User ID is required");
      
      const result = await usersApi.getUserCollections(userId, params);
      
      // Normalize and cache each collection individually
      result.collections.forEach((collection) => {
        const normalized = normalizeCollection(queryClient, collection);
        queryClient.setQueryData(["collection", collection.id], normalized);
      });
      
      // Return array of collection IDs
      return result.collections.map((collection) => collection.id);
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes - match existing pattern
  });
};